/* ============
 * Getters for the global module
 * ============
 *
 * The getters that are available on the
 * global module.
 */
export const assets = (state) => {
  return state.assets
}
export const total = (state) => {
  return state.total
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export const parentIsEncrypt = (state) => {
  return state.parentIsEncrypt
}
export default {
  assets,
  total,
  sort,
  order,
  parentIsEncrypt
}
